import User from 'helper/currentUser';

const user = new User();

export const getDefaultValues = () => {
  const values = [];

  const userId = user.id();
  if (userId) {
    values.push(userId);
  }

  const email = user.email();
  if (email) {
    values.push(email);
  }

  const companyId = user.companyId();
  if (companyId) {
    values.push(companyId);
  }

  return values;
};

export const evaluateFeatureFlag = ({ featureFlag, values = getDefaultValues() }) => {
  if (featureFlag) {
    const checkIfValueMatches = featureFlagField =>
      values.some(value => value === featureFlagField);

    const serveTrue = featureFlag.serveTrueFor ? JSON.parse(featureFlag.serveTrueFor) : [];
    const shouldServeTrue = serveTrue.some(checkIfValueMatches);

    if (shouldServeTrue) {
      return true;
    }

    const serveFalse = featureFlag.serveFalseFor ? JSON.parse(featureFlag.serveFalseFor) : [];
    const shouldServeFalse = serveFalse.some(checkIfValueMatches);

    if (shouldServeFalse) {
      return false;
    }

    return featureFlag.defaultServe;
  }

  return false;
};
